import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function userDetailsFilledFormatter({ stage }) {
  const email = window.GTMData?.email ?? null;
  const newUser = window.GTMData?.isNewUser ?? false;

  return getGTMEventData(EVENT_NAMES.USER_DETAILS_FILLED,
    email,
    { flowStageCompleted: stage, newUser });
}

export default userDetailsFilledFormatter;
